import React, { useEffect, useRef, useState } from "react";
import Robot from "../../assets/images/agentLite.svg";
import Appbot from "../../assets/images/appbot.svg";
import RapIcon from "../../assets/images/rap-bw.svg";
import VerifyMe from "../../assets/images/verify-me.svg";
import { cookies } from "../../utils/cookies";

import AppLauncherIcon from "./AppLauncherIcon";

const AppSwitcher1: React.FC = () => {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const authToken = cookies.get("token") as string;

  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="position-relative" ref={dropdownRef}>
      <div onClick={() => setOpen((prev) => !prev)}>
        <AppLauncherIcon />
      </div>

      {open && (
        <>
          <div
            style={{
              position: "absolute",
              top: "37px",
              left: "50%",
              transform: "translateX(-50%)",
              width: 0,
              height: 0,
              borderLeft: "10px solid transparent",
              borderRight: "10px solid transparent",
              borderBottom: "10px solid white", // match dropdown bg
            }}
          />
          <ul
            className="dropdown-menu show position-absolute mt-4"
            style={{
              marginLeft: "-100px",
              background: "#FFF",
              height: "170px",
              width: "180px",
              // display: "flex",
              flexDirection: "column",
              justifyContent: "space-evenly",
              alignItems: "center",
              border: "none",
              boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
              // padding: "0.5rem 0",
            }}
          >
            {[
              {
                label: "VerifyMe",
                href: `https://verifymedemo.rapidautomation.ai/login?token=${authToken}`,
                icon: VerifyMe,
              },
              {
                label: "RAPFlow",
                href: `https://rapflowdemo.rapidautomation.ai/login?token=${authToken}`,
                icon: RapIcon,
              },
              {
                label: "Agentic AI",
                href: `https://rapflowdemo.rapidautomation.ai/agentic-ai?token=${authToken}`,
                icon: Robot,
              },
              {
                label: "RAPBot",
                href: `https://demo.orchestrator.rapidautomation.ai/login?token=${authToken}`,
                icon: Appbot,
              },
            ].map((item) => (
              <li
                key={item.label}
                style={{
                  width: "100%",
                  textAlign: "left",
                  padding: "0.2rem 0",
                  fontSize: "14px",

                  // borderBottom:
                  //   index < 3 ? "1px solid rgba(0, 0, 0, 0.1)" : "none", // no border for last item
                }}
              >
                <a
                  className="dropdown-item"
                  href={item.href}
                  target="blank"
                  style={{ color: "#333333" }}
                >
                  <span>
                    <img
                      src={item.icon}
                      style={{ width: "24px", marginRight: "12px" }}
                    />
                  </span>
                  <span>{item.label}</span>
                  {/* {item.label} */}
                </a>
              </li>
            ))}
          </ul>
        </>
      )}
    </div>
  );
};

export default AppSwitcher1;
